<template>
	<div v-if="dataLoaded" style="margin-bottom: 10px; " class="read-only-offer-basic-section">
		<ContestOfferReadOnlyHeader :offer-data="offerData" :contest-configuration="contestConfiguration"/>
		<v-layout v-if="prioritiesSummary.tasks !== undefined">
			<v-flex xs12 md12>
				<v-card style="margin: 10px">
					<v-card-title style="background-color: #0075e2; color: #fff">
						<h3>Zadania, kraje i priorytety</h3>
					</v-card-title>
					<v-card-text>
						<div>
							<h4 v-for="task in prioritiesSummary.tasks" :key="task">
								&emsp; {{task}}
							</h4>
							<div v-if="prioritiesSummary.extraCountries.length">
								<v-divider style="margin-top: 20px; margin-bottom: 20px"/>
								<h4> Kraje dodatkowe</h4>
								<h4 v-for="(country) in prioritiesSummary.extraCountries" :key="country">
									&emsp; - {{country}}
								</h4>
							</div>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12 md12>
				<v-card style="margin: 10px">
					<v-card-title>
						<h3>{{contestConfiguration.numberOfModules > 1 ?
							'Czas trwania modułów' : 'Czas trwania projektu'}}</h3>
					</v-card-title>
					<v-card-text>
						<div
							v-for="i in (contestConfiguration.numberOfModules !== 0 ? contestConfiguration.numberOfModules : 1)"
							:key="i">
							<v-layout row>
								<v-flex sx4 style="margin-top: 5px">
									<h4>{{contestConfiguration.numberOfModules > 1 ? 'Moduł nr ' + i : 'Projekt'}}</h4>
								</v-flex>
								<v-flex sx4>
									<display-text-component
										:flex="'equal'"
										label="Data rozpoczęcia"
										class="duration-project"
										:value="offerData.stepsConstantData[i-1].dates.start"/>
								</v-flex>
								<v-flex sx4>
									<display-text-component
										:flex="'equal'"
										label="Data zakończenia"
										class="duration-project"
										:value="offerData.stepsConstantData[i-1].dates.end"/>
								</v-flex>
							</v-layout>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12>
				<ContestOfferSummaryBidderDetailsView title="Oferent" class="bidder-card"
					:bidderId="bidderId" :offerId="$route.params.offerId"/>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12>
				<div v-for="(id, index) in otherBiddersId" :key="id">
					<ContestOfferSummaryBidderDetailsView :title="'Współoferent nr: ' + (index+1).toString()"
						:bidderId="id" :offerId="$route.params.offerId"/>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import displayTextComponent from "./DisplayTextComponent";
	import ContestOfferSummaryBidderDetailsView from "./ContestOfferSummaryBidderDetailsView";
	import {Offer} from "@/api/generated/Offer";
	import ContestOfferReadOnlyHeader from "./ContestOfferReadOnlyHeader";

	export default {
		name: "ContestOfferSummary",

		components: {
			ContestOfferReadOnlyHeader,
			displayTextComponent,
			ContestOfferSummaryBidderDetailsView
		},

		props: {
			contestConfiguration: Object,
			offerData: Object,
		},

		data () {
			return {
				prioritiesSummary: {},
				offerSummaryData: {},
				bidderId: 0,
				subBidders: [],
				otherBiddersId: [],
				offerDataLoaded: false,
				contestConfigurationLoaded: false
			};
		},

		computed: {
			dataLoaded: function () {
				return this.offerDataLoaded && this.contestConfigurationLoaded;
			}
		},

		watch: {
			offerData: {
				immediate: true,
				handler (val) {
					this.bidderId = val.mainBidderId;
					this.otherBiddersId = val.otherBiddersId;
					this.offerDataLoaded = true;
					let version = "";
					if ( this.$route.params.version) {
						version =  this.$route.params.version;
					}
					Offer.getOfferPrioritiesSummary(this, this.offerData.id, version, response => this.prioritiesSummary = response);
				}
			},
			contestConfiguration: {
				immediate: true,
				handler () {
					this.contestConfigurationLoaded = true;
				}
			}
		},
	};
</script>

<style scoped>
</style>
